export default __webpack_public_path__ + "static/media/577_06-18-2022_Jennifer+Jack_Wedding.e6d7df56.jpg";